import { render, staticRenderFns } from "./delivery-email-text.vue?vue&type=template&id=69328c9e"
import script from "./delivery-email-text.vue?vue&type=script&lang=js"
export * from "./delivery-email-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports